import { render, staticRenderFns } from "./AdmissionCheckResult.vue?vue&type=template&id=4068b57c&scoped=true"
import script from "./AdmissionCheckResult.vue?vue&type=script&lang=js"
export * from "./AdmissionCheckResult.vue?vue&type=script&lang=js"
import style0 from "./AdmissionCheckResult.vue?vue&type=style&index=0&id=4068b57c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4068b57c",
  null
  
)

export default component.exports